import React from 'react'
import movDev from './img/interface-pana.png'
import { StyledComingSoon } from './styled'

export default () => {
  return (
    <StyledComingSoon>
      <div className={'comingsoon-content'}>
        <img src={movDev} alt="Đang phát triển"/>
        <p className={"title-page"}> Tính năng đang phát triển </p>
        <p className={"content-page"}> Tính năng này sẽ sớm được ra mắt thôi, vì vậy hãy theo dõi DTP Education bạn nhé! </p>
      </div>
    </StyledComingSoon>
  )
}